import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Shield, Lock, Eye, CheckCircle, Lightbulb } from 'lucide-react';
import { Button } from '../components/ui/button';

const DataPrivacyPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleContinue = () => {
    // Pass along any state that was received (like scrapedProfile)
    navigate('/onboarding', { state: location.state });
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#FDFBF7] p-6 text-center">
      <div className="max-w-md w-full space-y-8 animate-in fade-in zoom-in duration-500">

        {/* Success checkmark */}
        <div className="flex justify-center mb-2">
          <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center border-4 border-white shadow-lg">
             <CheckCircle className="w-8 h-8 text-green-600" />
          </div>
        </div>

        <p className="text-green-600 font-medium text-lg">you're in!</p>

        {/* Icon Cluster */}
        <div className="flex justify-center -space-x-4 mb-6 mt-8">
          <div className="w-14 h-14 rounded-full bg-blue-100 flex items-center justify-center border-4 border-white shadow-lg z-10">
             <Eye className="w-7 h-7 text-blue-600" />
          </div>
          <div className="w-14 h-14 rounded-full bg-purple-100 flex items-center justify-center border-4 border-white shadow-lg z-20">
             <Shield className="w-7 h-7 text-purple-600" />
          </div>
          <div className="w-14 h-14 rounded-full bg-green-100 flex items-center justify-center border-4 border-white shadow-lg z-10">
             <Lock className="w-7 h-7 text-green-600" />
          </div>
        </div>

        <div className="space-y-4">
          <h1 className="text-2xl font-bold text-slate-900">
            quick heads up before we start
          </h1>

          <p className="text-slate-500 text-sm">
            the more we know about you, the better we can map out a career path that actually fits your life.
          </p>

          <div className="text-left space-y-4 bg-white rounded-xl p-5 border border-slate-100 shadow-sm">
            <div className="flex items-start gap-3">
              <Lightbulb className="w-5 h-5 text-purple-500 mt-0.5 flex-shrink-0" />
              <p className="text-slate-600 text-sm leading-relaxed">
                <span className="font-semibold text-slate-800">fig is your ai career advisor.</span> we'll analyze your background and interests to build you a personalized career roadmap.
              </p>
            </div>

            <div className="flex items-start gap-3">
              <Eye className="w-5 h-5 text-blue-500 mt-0.5 flex-shrink-0" />
              <p className="text-slate-600 text-sm leading-relaxed">
                <span className="font-semibold text-slate-800">we'll ask for your resume + youtube history.</span> your youtube watch history tells us what you're genuinely curious about (way more honest than what people put on linkedin).
              </p>
            </div>

            <div className="flex items-start gap-3">
              <Lock className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" />
              <p className="text-slate-600 text-sm leading-relaxed">
                <span className="font-semibold text-slate-800">we only extract key themes.</span> we don't store your full history, just the patterns that help us understand you better.
              </p>
            </div>
          </div>
        </div>

        <div className="pt-6">
          <Button
            onClick={handleContinue}
            className="w-full h-12 text-lg bg-black hover:bg-slate-800 text-white rounded-full transition-all shadow-lg hover:shadow-xl"
          >
            got it, let's go
          </Button>
          <p className="mt-4 text-xs text-slate-400">
            your privacy is our top priority. read our full{' '}
            <a
              href="/privacy"
              className="underline hover:text-slate-600"
            >
              privacy policy
            </a>
            .
          </p>
        </div>

      </div>
    </div>
  );
};

export default DataPrivacyPage;
